import { IkasOrderAddress } from "./address";
import { IkasOrderShippingLine } from "./shipping-line";
import { IkasOrderLineItem } from "./line-item";
import { IkasOrderCustomer } from "./customer";
import { IkasOrderGiftPackageLine } from "./gift-line";
import { IkasInvoice } from "./invoice";
import { IkasOrderPaymentMethod } from "./payment-method";
import { IkasOrderAdjustment } from "./adjustment";
import { IkasOrderPackage } from "./package";
import { IkasOrderTaxLine } from "./tax-line";
import { IkasBaseModel } from "../base";

export type IkasOrder = {
  billingAddress: IkasOrderAddress | null;
  cancelReason: IkasOrderCancelReason | null;
  cancelledAt: number | null;
  currencyCode: string;
  currencySymbol: string | null;
  customer: IkasOrderCustomer | null;
  customerId: string | null;
  giftPackageLines: IkasOrderGiftPackageLine[] | null;
  giftPackageNote: string | null;
  invoices: IkasInvoice[] | null;
  isGiftPackage: boolean | null;
  note: string | null;
  orderAdjustments: IkasOrderAdjustment[] | null;
  orderLineItems: IkasOrderLineItem[];
  orderNumber: string | null;
  orderPackageStatus: IkasOrderPackageStatus | null;
  orderPackages: IkasOrderPackage[] | null;
  orderPaymentStatus: IkasOrderPaymentStatus | null;
  orderedAt: number | null;
  paymentMethods: IkasOrderPaymentMethod[] | null;
  shippingAddress: IkasOrderAddress | null;
  shippingLines: IkasOrderShippingLine[] | null;
  shippingMethod: IkasOrderShippingMethod;
  status: IkasOrderStatus;
  taxLines: IkasOrderTaxLine[] | null;
  totalFinalPrice: number;
  totalPrice: number;
} & IkasBaseModel;

export enum IkasOrderCancelReason {
  CUSTOMER = "CUSTOMER",
  DECLINED = "DECLINED",
  INVENTORY = "INVENTORY",
  OTHER = "OTHER",
}

export enum IkasOrderPackageStatus {
  CANCELLED = "CANCELLED",
  CANCEL_REJECTED = "CANCEL_REJECTED",
  CANCEL_REQUESTED = "CANCEL_REQUESTED",
  DELIVERED = "DELIVERED",
  FULFILLED = "FULFILLED",
  PARTIALLY_CANCELLED = "PARTIALLY_CANCELLED",
  PARTIALLY_DELIVERED = "PARTIALLY_DELIVERED",
  PARTIALLY_FULFILLED = "PARTIALLY_FULFILLED",
  PARTIALLY_REFUNDED = "PARTIALLY_REFUNDED",
  READY_FOR_PICK_UP = "READY_FOR_PICK_UP",
  READY_FOR_SHIPMENT = "READY_FOR_SHIPMENT",
  REFUNDED = "REFUNDED",
  REFUND_REJECTED = "REFUND_REJECTED",
  REFUND_REQUESTED = "REFUND_REQUESTED",
  REFUND_REQUEST_ACCEPTED = "REFUND_REQUEST_ACCEPTED",
  UNABLE_TO_DELIVER = "UNABLE_TO_DELIVER",
  UNFULFILLED = "UNFULFILLED",
}

export enum IkasOrderPaymentStatus {
  PAID = "PAID",
  PARTIALLY_PAID = "PARTIALLY_PAID",
  WAITING = "WAITING",
}

export enum IkasOrderStatus {
  CANCELLED = "CANCELLED",
  CREATED = "CREATED",
  DRAFT = "DRAFT",
  PARTIALLY_CANCELLED = "PARTIALLY_CANCELLED",
  PARTIALLY_REFUNDED = "PARTIALLY_REFUNDED",
  REFUNDED = "REFUNDED",
  REFUND_REJECTED = "REFUND_REJECTED",
  REFUND_REQUESTED = "REFUND_REQUESTED",
}

export enum IkasOrderShippingMethod {
  CLICK_AND_COLLECT = "CLICK_AND_COLLECT",
  NO_SHIPMENT = "NO_SHIPMENT",
  SHIPMENT = "SHIPMENT",
  DIGITAL_DELIVERY = "DIGITAL_DELIVERY",
}
